import { ACCESS_MODE, DeviceType, Template } from '@horasys/bellplus/common/types';

import {
	ADD_TEMPLATE,
	GET_TEMPLATES_LIST,
	GET_TEMPLATES_LIST_BY_DEVICE_TYPE,
	RESET_TEMPLATE_FORM,
	RESET_TEPLATES_BY_DEVICE_TYPE,
	TemplateAction,
} from 'store/types/template';

export interface TemplateStore {
	adminlist: Array<any>;
	standardList: Array<any>;
	clientList: Array<any>;
	clientId: number;
	error: any;
	loading: boolean;
	mode: ACCESS_MODE;
	selectedId: number;
	template: Template;
	tempDeviceTypeTemplateList: Array<Template>;
}
const emptyDeviceType: DeviceType = {
	id: 0,
	deviceType: '',
	qrScannerEnabled: false,
	height: 0,
	width: 0,
};
const emptyTemplate: Template = {
	name: '',
	templateUrl: '',
	duration: 0,
	thumbnailAssetId: 2,
	assets: [],
	id: 0,
	deviceType: emptyDeviceType,
	standard: false,
};
const initialState: TemplateStore = {
	adminlist: [],
	standardList: [],
	clientId: 0,
	clientList: [],
	error: null,
	loading: false,
	mode: 'CREATE',
	selectedId: 0,
	tempDeviceTypeTemplateList: [],
	template: emptyTemplate,
};
export const templateReducer = (
	state = initialState,
	action: TemplateAction,
): TemplateStore => {
	switch (action.type) {
		case GET_TEMPLATES_LIST: {
			return {
				...state,
				adminlist: action.payload,
			};
		}
		case GET_TEMPLATES_LIST_BY_DEVICE_TYPE: {
			return {
				...state,
				tempDeviceTypeTemplateList: [
					...state.tempDeviceTypeTemplateList,
					...action.payload,
				],
			};
		}

		case RESET_TEPLATES_BY_DEVICE_TYPE: {
			return {
				...state,
				tempDeviceTypeTemplateList: [],
			};
		}

		case RESET_TEMPLATE_FORM: {
			return {
				...state,
				template: emptyTemplate,
			};
		}

		case ADD_TEMPLATE: {
			return {
				...state,
				tempDeviceTypeTemplateList: [
					...state.tempDeviceTypeTemplateList,
					action.payload,
				],
			};
		}

		default: {
			return {
				...state,
			};
		}
	}
};
